import React from 'react';
import '../Responsive.css';

const ProjectCard = ({ imageSrc, title, stack, description, githubLink, demoLink }) => {
  return (
    <div className="projborder max-w-sm  overflow-hidden shadow-lg transform transition-transform duration-300 hover:scale-105 ml-10 mr-10 mt-3 p-4  bg-slate-900  opacity-90  rounded-lg  ">
      <img className="w-full" src={imageSrc} alt="Project" />
      <div className="px-2 py-4">
        <div className="font-bold text-xl mb-2 text-center">{title}</div>
        <div className="font-semibold text-lg mb-2 text-center">{stack}</div>
        <p className="text-gray-100 text-base">{description}</p>
      </div>
      <div className="px-6 py-4 flex justify-center">
        <a
          href={githubLink}
          className="cssbuttons-io inline-block bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
  <path d="M12 0a12 12 0 0 0-3.78 23.4c.6.12.82-.26.82-.58v-2.03c-3.34.72-4.04-1.61-4.04-1.61-.55-1.39-1.34-1.76-1.34-1.76-1.1-.75.08-.73.08-.73 1.22.08 1.86 1.23 1.86 1.23 1.08 1.85 2.82 1.31 3.5 1 .11-.79.42-1.32.76-1.62-2.67-.3-5.47-1.34-5.47-5.96 0-1.32.48-2.4 1.23-3.24-.13-.3-.54-1.53.12-3.18 0 0 1-.32 3.3 1.23.96-.27 1.98-.4 3-.4s2.04.13 3 .4c2.3-1.55 3.3-1.23 3.3-1.23.67 1.65.26 2.88.13 3.18.75.84 1.23 1.92 1.23 3.24 0 4.63-2.8 5.66-5.47 5.96.43.37.81 1.11.81 2.24v3.32c0 .32.22.7.83.58A12 12 0 0 0 12 0"/>
</svg>
            GitHub
          </span>
        </a>
        {demoLink && (
          <a
            href={demoLink}
            className="cssbuttons-io inline-block bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
</svg>

              Demo
            </span>
          </a>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
